import React, { FunctionComponent } from 'react';
import {
  Skeleton,
  SkeletonBox,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from '@bitrise/bitkit';
import { BuildAttributes, BuildRow } from '@trace/types';
import BuildBreakdownTableRow from './BuildBreakdownTableRow';

interface Props {
  dataSummary: BuildRow[];
  groupBy: keyof BuildAttributes;
  isFetching: boolean;
  onRowClick?: (data: BuildRow) => void;
}

const BuildBreakdownTable: FunctionComponent<Props> = ({
  dataSummary,
  groupBy,
  isFetching,
  onRowClick,
}) => {
  return (
    <Skeleton active={isFetching}>
      <Table type="flat">
        <TableHeader>
          <TableHeaderRow>
            <TableHeaderCell titlecase>{groupBy}</TableHeaderCell>

            <TableHeaderCell>Avg Build Time</TableHeaderCell>
            <TableHeaderCell>Total Build Minutes</TableHeaderCell>
            <TableHeaderCell align="middle">Success Rate</TableHeaderCell>
            <TableHeaderCell>Build History</TableHeaderCell>

            {onRowClick && <TableHeaderCell />}
          </TableHeaderRow>
        </TableHeader>

        <TableBody>
          {isFetching &&
            Array.from({ length: 5 }).map((_, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <TableRow key={i}>
                <TableCell>
                  <SkeletonBox height="16px" width="120px" />
                </TableCell>
                <TableCell>
                  <SkeletonBox height="16px" width="80px" />
                </TableCell>
                <TableCell>
                  <SkeletonBox height="16px" width="120px" />
                </TableCell>
                <TableCell>
                  <SkeletonBox borderRadius="rounded" height="60px" width="60px" />
                </TableCell>
                <TableCell>
                  <SkeletonBox borderRadius="x4" height="60px" width="100%" />
                </TableCell>
                <TableCell />
              </TableRow>
            ))}

          {!isFetching &&
            dataSummary.map((data) => (
              <BuildBreakdownTableRow
                dataSummary={data}
                groupBy={groupBy}
                key={data[groupBy]}
                onClick={onRowClick && (() => onRowClick(data))}
              />
            ))}
        </TableBody>
      </Table>
    </Skeleton>
  );
};

export default BuildBreakdownTable;
